exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tr.dragging {\n  background: #eee; }\n\ntable td a.handle {\n  font-size: 20px;\n  font-weight: bold;\n  cursor: all-scroll;\n  display: inline-block;\n  padding: 5px;\n  color: #666; }\n  table td a.handle:hover {\n    color: #333; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/DocumentsModule/DocumentEditComponent/document-edit.component.scss
// module id = ../../../../../src/DocumentsModule/DocumentEditComponent/document-edit.component.scss
// module chunks = main